// src/store/contactSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CompanyResponse, deleteCompany, fetchAllContacts } from "../../../api/contact";

interface ContactState {
  contacts: CompanyResponse[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: ContactState = {
  contacts: [],
  status: 'idle',
  error: null,
};

export const loadContacts = createAsyncThunk(
  'contacts/loadContacts',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchAllContacts();
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to load contacts');
    }
  }
);

export const deleteContact = createAsyncThunk(
  'contacts/deleteContact',
  async (contactId: string, { rejectWithValue }) => {
    try {
      await deleteCompany(contactId); // API call
      return contactId; // returning deleted contactId to update state
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to delete contact');
    }
  }
);

const contactSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    clearContacts: (state) => {
      state.contacts = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadContacts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(loadContacts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.contacts = action.payload;
      })
      .addCase(loadContacts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      })
      .addCase(deleteContact.fulfilled, (state, action) => {
  state.contacts = state.contacts.filter(
    (contact) => contact.company.contact_id !== action.payload
  );
})
.addCase(deleteContact.rejected, (state, action) => {
  state.error = action.payload as string;
});
  },
});

export const { clearContacts } = contactSlice.actions;
export default contactSlice.reducer;
